// extracted by mini-css-extract-plugin
module.exports = {"label":"CustomSelect_label__c_wD1","errorMessage":"CustomSelect_errorMessage__te568"};